import { intl } from 'common/components/l10n/IntlGlobalProvider'
import { DEFAULT_LANGUAGE } from 'common/utils/constants'

const normalizeLanguageCode = (locale) => {
  // We want to ensure that the locale passed in is just treated as a language code
  // Ie. en-gb should be returned as 'en'
  // If no locale is passed in, just return the default language code ('en')
  if (!locale) {
    return DEFAULT_LANGUAGE
  }
  return locale.substr(0, 2).toLowerCase()
}

export const getActiveLanguageCode = () => {
  const locale = intl.getLocale()
  const languageCode = normalizeLanguageCode(locale)

  return languageCode
}

export const getLocaleFromLanguageCode = (languageCode) => {
  // default to en-gb if language is en so the dates and currencies
  // are more geared towards all English speakers instead of just Americans
  // (ex: a date in en-GB could be 12 June 2018 while in en it'd be June 12, 2018)
  switch (languageCode) {
    case 'en': return 'en-gb'
    default: return languageCode
  }
}

